module.exports = __webpack_public_path__ + "static/media/photo_coming_soon.bac1bfa2.jpg";